module.exports = __webpack_public_path__ + "static/media/RightArrow.21432266.svg";